module.exports = __webpack_public_path__ + "static/media/CompanyProfilebg@2x.9178ea76.png";